import { useLayoutEffect, useRef, useState } from 'react';
import { Form } from 'antd';
import { AppPasswordInput } from '../../../components/shared/AppPasswordInput';
import { generatePassword } from '../../../components/shared/AppPasswordInput/generatePassword';
import type { Props } from './types';
import styles from './style.module.css';

type UserPasswordFieldProps = Pick<
  Props,
  | 'password'
  | 'onPasswordChange'
  | 'onPasswordGenerated'
  | 'handleFocus'
  | 'errors'
  | 'submitting'
>;

export const UserPasswordField = ({
  password,
  onPasswordChange,
  onPasswordGenerated,
  handleFocus,
  errors,
  submitting,
}: UserPasswordFieldProps) => {
  const [passwordVersion, setPasswordVersion] = useState(0);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const visibilityBeforeGeneration = useRef(false);

  useLayoutEffect(() => {
    setPasswordVisible(visibilityBeforeGeneration.current);
  }, [passwordVersion]);

  return (
    <div className={styles.selectReport}>
      <label className={styles.titleSelect} htmlFor="new-user-password">
        Пароль <span className={styles.requiredMark}>*</span>
      </label>
      <Form.Item
        validateStatus={errors.password?.validateStatus || ''}
        help={errors.password?.help || ''}
      >
        <AppPasswordInput
          key={passwordVersion}
          id="new-user-password"
          name="password"
          autoComplete="new-password"
          autoFocus={passwordVersion > 0}
          placeholder="Введите пароль"
          value={password}
          onChange={onPasswordChange}
          onFocus={() => handleFocus('password')}
          visibilityToggle={{
            visible: passwordVisible,
            onVisibleChange: setPasswordVisible,
          }}
          onGeneratePassword={() => {
            const generatedPassword = generatePassword();
            handleFocus('password');
            onPasswordGenerated(generatedPassword);
            visibilityBeforeGeneration.current = passwordVisible;
            setPasswordVisible(false);
            // Chrome preserves typed passwords per input node over script changes.
            setPasswordVersion((version) => version + 1);
          }}
          showHint={true}
          disabled={submitting}
        />
      </Form.Item>
    </div>
  );
};
